<template>
  <tr>
    <td>
      <sui-button v-for="action in actionList" v-bind:content="action" v-on:click="buttonAction(action)"
        v-bind:key="action" />
    </td>
    <td>{{ test.class ? test.class.name : 'N/A' }}</td>
    <td>
      <a v-bind:href="this.studentAppUrl" target="_blank">
        {{ studentAppUrl }}
      </a>
    </td>
    <td>{{ test.createdOn | moment('DD-MM-YYYY HH:mm:ss') }}</td>
    <td>{{ test.codeValidUntil | moment('DD-MM-YYYY HH:mm:ss') }}</td>
    <td>{{ test.amountOfStudents }}</td>
    <td>{{ test.progress }}</td>
  </tr>
</template>

<script>
const studentAppBaseUrl = process.env.STUDENT_APP_URL;
export default {
  name: 'TestTableRow',
  props: ['test', 'actions'],
  computed: {
    actionList() {
      return this.actions || [];
    },
    studentAppUrl() {
      return `${studentAppBaseUrl}/${this.test.code}`;
    }
  },
  methods: {
    buttonAction(value) {
      this.$emit('action', { action: value, id: this.test.id });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestTableRow.vue